import { Injectable } from '@angular/core';
import { CONFIG } from '../../environments/config';
import { HttpClientService } from './http-client.service';

@Injectable({ providedIn: 'root' })
export class EInvoiceService {

    constructor(private httpClientService: HttpClientService) { }

    getAll() {
        return this.httpClientService.get(CONFIG.EINVOICE.GET_ALL);
    }

    // generateIRN(id: number) {
    //     return this.httpClientService.post(
    //         `${CONFIG.EINVOICE.GENERATE_EINVOICE}/${id}`, {}
    //     );
    // }
    generateIRN(id: number, payload: any) {
        return this.httpClientService.post(
            `${CONFIG.EINVOICE.GENERATE_EINVOICE}/${id}`, payload
        );
    }

    retryIRN(id: number) {
        return this.httpClientService.post(
            `${CONFIG.EINVOICE.RETRY_EINVOICE}/${id}`, {}
        );
    }

    // cancelIRN(id: number) {
    //     return this.httpClientService.post(
    //         `${CONFIG.EINVOICE.CANCEL_EINVOICE}/${id}`, {}
    //     );
    // }
    cancelIRN(payload: any) {
        return this.httpClientService.post(
            `${CONFIG.EINVOICE.CANCEL_EINVOICE}/${payload.salesOrderId}`,
            payload
        );
    }


    validateIRN(id: number) {
        return this.httpClientService.get(`${CONFIG.EINVOICE.VALIDATE_EINVOICE}/${id}`);
    }

    //settings
    saveSettings(data: any) {
        return this.httpClientService.post(`${CONFIG.EINVOICE.SAVE_EINVOICESETTINGS}`, data);
    }

    updateSettings(data: any) {
        return this.httpClientService.post(`${CONFIG.EINVOICE.UPDATE_EINVOICESETTINGS}`, data);
    }
    disableSettings(id: number) {
        return this.httpClientService.post(`${CONFIG.EINVOICE.DISABLE_EINVOICESETTINGS}/${id}`, {});
    }

    getSettings() {
        return this.httpClientService.get(`${CONFIG.EINVOICE.GET_SETTINGS}`);
    }

    getEInvoiceStatus() {
        return this.httpClientService.get(`${CONFIG.EINVOICE.GET_EINVOICE_STATUS}`);
    }

    // downloadPdf(id: number) {
    //     return this.httpClientService.getFile(
    //         `${CONFIG.EINVOICE.DOWNLOAD_PDF}/${id}`
    //     );
    // }
}
